module.exports = __webpack_public_path__ + "img/icons-aside.6c220c16.svg";